import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../configureStore";
import { Applicant, signInUser } from "../../redux/reducer/applicant";
import { AxiosResponse } from "axios";
import { Spin } from "antd";

interface MagicLinkPageParams {
}

const MagicLinkPage = ({
}: MagicLinkPageParams) => {
    const dispatch = useDispatch<AppDispatch>();
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const getAuth = useCallback(() => {
        const token = params.get('token');
        const check = params.get('check');

        if (token && check) {
            dispatch(signInUser({
                input: {
                    l: encodeURIComponent(window.location.host),
                    token,
                    check,
                },
                onSuccess: (res: AxiosResponse<{ tokens: { accessToken: string; refreshToken: string; }; applicant: Applicant; }>) => {
                    localStorage.setItem('accessToken', res.data.tokens.accessToken);
                    const accessTokens = JSON.stringify([...JSON.parse(localStorage.getItem('accessTokens') ?? '[]') as string[], res.data.tokens.accessToken]);
                    localStorage.setItem('accessTokens', accessTokens);

                    if (res.data.tokens.refreshToken) {
                        localStorage.setItem('refreshToken', res.data.tokens.refreshToken);
                        const refreshTokens = JSON.stringify([...JSON.parse(localStorage.getItem('refreshTokens') ?? '[]') as string[], res.data.tokens.refreshToken]);
                        localStorage.setItem('refreshTokens', refreshTokens);
                    }
                    navigate('/')
                }
            }));
        }
    }, [params]);

    const hasCalled = useRef(false);

    useEffect(() => {
        if (hasCalled.current) return;
        hasCalled.current = true;

        getAuth();
    }, []);

    return <Spin fullscreen />;
};

export default MagicLinkPage;
